/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { Flex, UnstyledButton } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'

import type { AdvisorSelectProps } from '@/modules/advisorsPage/components/AdvisorSelect/AdvisorSelect.types'
import { AdvisorsList } from '@/modules/advisorsPage/components/AdvisorsList/AdvisorsList'

import { TextInput } from '@/components/TextInput/TextInput'

import CloseIcon from '@/assets/icons/close.svg?react'

import classes from './AdvisorSelect.module.css'

export function AdvisorSelect({
  advisors,
  allowedAdvisors,
  isLoading,
  onSearchAdvisor,
  onSelectAdvisor,
  searchedAdvisor,
  selectedAdvisorId,
}: AdvisorSelectProps) {
  const [localSearch, setLocalSearch] = useState<string>(searchedAdvisor)

  const handleDebouncedSearch = useDebouncedCallback((value: string) => {
    if (value.length < 3 && value.length > 0) return
    onSearchAdvisor(value)
  }, 500)

  return (
    <Flex className={classes.container} direction="column">
      <TextInput
        autoComplete="off"
        onChange={e => {
          setLocalSearch(e.target.value)
          handleDebouncedSearch(e.target.value)
        }}
        placeholder="Search (min. 3 characters)"
        rightSection={
          localSearch && (
            <UnstyledButton
              className={classes.inputClear}
              onClick={() => {
                setLocalSearch('')
                onSearchAdvisor('')
              }}
            >
              <CloseIcon />
            </UnstyledButton>
          )
        }
        spellCheck="false"
        styles={{
          input: {
            paddingRight: 32,
          },
        }}
        value={localSearch}
      />

      <AdvisorsList
        advisors={advisors}
        allowedAdvisors={allowedAdvisors}
        isLoading={isLoading}
        onSelectAdvisor={onSelectAdvisor}
        selectedAdvisorId={selectedAdvisorId}
      />
    </Flex>
  )
}
